﻿module.exports = {
    bindings: {
        measure: '<'
    },
    templateUrl: 'additional-codes/components/measure-additional-code-buttons.html'
};